var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg162(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "174") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-night",
    transform: "translate(-2366.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 174,
    transform: "translate(2366.398961, 13.396364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48311688,0 C7.60342217,0 8.65735029,0.28414858 9.57676402,0.78430852 C7.75027743,2.32525347 6.52822983,4.55970479 6.31645091,7.08155844 L6.31645091,7.08155844 L5.78523429,7.08155844 C3.73949522,7.08155844 1.92626436,8.07432304 0.80064591,9.60423403 C0.289966462,8.67881302 0,7.61483307 0,6.48311688 C0,2.9025413 2.9025413,0 6.48311688,0 Z",
    id: "Combined-Shape",
    fill: "#BEE4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1249704,4.98701299 C27.4493573,4.98701299 29.5020612,6.40162887 30.3474453,8.49838823 L30.4305538,8.71769766 L30.6791429,9.41674026 L21.2836337,9.41688312 L18.8791429,17.9527403 L17.6207127,17.9532468 C15.8197029,17.9532468 14.3625974,16.5025247 14.3625974,14.715279 C14.3625974,12.9897587 15.7206665,11.5777678 17.4357347,11.4824408 L17.6208125,11.4773112 L19.4042681,11.4773112 L19.5199668,10.10688 C19.762934,7.22488519 22.1949008,4.98701299 25.1249704,4.98701299 Z M15.5465143,0.0997402597 C18.3983915,0.0997402597 20.9647419,1.65007416 22.3208116,4.06195096 C20.0394921,5.03624921 18.372135,7.16318619 18.0576351,9.70708471 L18.0291491,9.98120727 L17.6207127,9.98120727 C14.9943522,9.98120727 12.8664935,12.1006878 12.8664935,14.715279 C12.8664935,15.8845731 13.2920523,16.9546811 13.9973268,17.780527 L14.1526853,17.9537024 L5.78523429,17.9532468 C3.19567792,17.9532468 1.09714286,15.8549112 1.09714286,13.2654545 C1.09714286,10.7481212 3.0806176,8.69462626 5.57060114,8.5824856 L5.78523429,8.57766234 L7.69216831,8.57766234 L7.80726857,7.20673247 C8.14339325,3.20395636 11.5027449,0.0997402597 15.5465143,0.0997402597 Z M32.7258764,9.64478338 C35.0347636,9.64478338 36.9038961,11.5060364 36.9038961,13.7990649 C36.9038961,16.0224144 35.146328,17.8400413 32.934524,17.9481588 L32.7258764,17.9532468 L31.9201429,17.9527403 L33.4532767,15.4037252 L28.2313742,15.4037252 L30.7781429,9.69574026 L30.845573,9.88645403 L32.0710816,9.69525195 C32.2858223,9.66173922 32.504453,9.64478338 32.7258764,9.64478338 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FED100",
    points: "22.4196241 10.9168831 19.7485714 20.4037252 24.3538346 20.4037252 21.7748872 31.9168831 30.801203 16.9037252 25.9196241 16.9037252 28.5906767 10.9168831"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg162);
export default __webpack_public_path__ + "static/media/162.bb6f59f620e92d35357a9dd6945cdc11.svg";
export { ForwardRef as ReactComponent };